// 指定图表的配置项和数据
export const option = {
  // 图标的标题
  title: {
    text: "成绩分布情况",
    //   subtext: "Fake Data",
    left: "center"
  },
  // 工具提示(鼠标悬停展示的内容)
  tooltip: {
    trigger: "item"
    //   formatter: function(params) {
    //     var res = params.grade + "：" + params.data.Proportion + "<br/>";
    //     // res += "当前时段点击人数：" + params.data.renShu+ "<br/>";
    //     // res += "当前时段停留时长：" + params.data.stayTime+ "<br/>";
    //     return res;
    //   },
  },
  // 切换显示信息
  legend: {
    // orient: "vertical",
    // right: "bottom",
    // top: "center",
    // x : '46%',
    // y : '82%',
    bottom: 10,
  },
  
  series: [
    {
      name: "当前时段点击次数",
      type: "pie",
      radius: "50%",
      data: [
        { value: 1048, name: "Search Engine" },
        { value: 735, name: "Direct" },
        { value: 580, name: "Email" },
        { value: 484, name: "Union Ads" },
        { value: 300, name: "Video Ads" }
      ],
      label: {},
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      }
    }
  ]
};
// 列表四的柱状图
export const columnarOne = {
  title: {
    text: '单元考试排名TOP10',
    x:'center',
    y:'top',
    align:'center',
    textStyle:{
        color:'#666666',
        fontWeight:'bolder',
        fontSize:28
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  toolbox: {
    feature: {
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ['line', 'bar'] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  legend: {
    bottom: 10,
    // data: ['Evaporation', 'Precipitation', 'Temperature']
  },
  xAxis: [
    {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisPointer: {
        type: 'shadow'
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: '平均成绩',
      min: 0, // 最小
      // max: 250, // 最大
      // interval: 50, // 数据间隔
      // axisLabel: {
      //   formatter: '{value} ml' // 类型
      // }
    },
    {
      type: 'value',
      name: '参与率',
      min: 0,
      max: 100,
      // interval: 5,
      axisLabel: {
        formatter: '{value} %'
      }
    }
  ],
  series: [
    {
      name: '平均成绩',
      type: 'bar',
      tooltip: {
        valueFormatter: function (value) {
          return value + ' 分';
        }
      },
      data: [
        2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
      ]
    },
    // {
    //   name: 'Precipitation',
    //   type: 'bar', // line 展示折线  bar展示柱状
    //   tooltip: {
    //     valueFormatter: function (value) {
    //       return value + ' ml';
    //     }
    //   },
    //   data: [
    //     2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
    //   ]
    // },
    {
      name: '参与率',
      type: 'line',
      yAxisIndex: 1,
      tooltip: {
        valueFormatter: function (value) {
          return value + ' %';
        }
      },
      data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
    }
  ]
}
// 列表五的柱状图
export const columnarTwo = {
  title: {
    text: '各岗位考试情况',
    x:'center',
    y:'top',
    align:'center',
    textStyle:{
        color:'#666666',
        fontWeight:'bolder',
        fontSize:28
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  toolbox: {
    feature: {
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ['line', 'bar'] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  legend: {
    bottom: 10,
    // data: ['Evaporation', 'Precipitation', 'Temperature']
  },
  xAxis: [
    {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisPointer: {
        type: 'shadow'
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: '参考人数',
      min: 0, // 最小
      // max: 250, // 最大
      // interval: 50, // 数据间隔
      // axisLabel: {
      //   formatter: '{value} ml' // 类型
      // }
    },
    {
      type: 'value',
      name: '参考率',
      min: 0,
      max: 100,
      // interval: 5,
      axisLabel: {
        formatter: '{value} %'
      }
    }
  ],
  series: [
    {
      name: '参考人数',
      type: 'bar',
      tooltip: {
        valueFormatter: function (value) {
          return value + ' 人';
        }
      },
      data: [
        2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
      ]
    },
    // {
    //   name: 'Precipitation',
    //   type: 'bar', // line 展示折线  bar展示柱状
    //   tooltip: {
    //     valueFormatter: function (value) {
    //       return value + ' ml';
    //     }
    //   },
    //   data: [
    //     2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
    //   ]
    // },
    {
      name: '参考率',
      type: 'line',
      yAxisIndex: 1,
      tooltip: {
        valueFormatter: function (value) {
          return value + ' %';
        }
      },
      data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
    }
  ]
}